import { combineReducers } from "redux";

import { generateCrudRedux, ICRUDReduxState } from "../../../../core/redux";
import { IBudgetHistory, IBudgetHistoryForm } from "../../data/entities";
import { BudgetHistoryRepoImpl } from "../../data/repo";

export const budgetHistoryRedux = generateCrudRedux<IBudgetHistory, IBudgetHistoryForm>({
  actionTypeName: "BudgetHistory",
  repository: BudgetHistoryRepoImpl,
});

export interface IBudgetHistoryReduxState extends ICRUDReduxState<IBudgetHistory> {}

export const BudgetHistoryReducers = combineReducers<IBudgetHistoryReduxState>({
  ...budgetHistoryRedux.reducer,
});
